var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","height":"100%"}},[(_vm.advertising1)?_c('img',{staticStyle:{"width":"100%","height":"100%"},attrs:{"src":_vm.advertising1.img_url,"alt":"","srcset":""}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }